import { __name } from './chunk-2JTKI4GS.mjs';
import { Component } from 'react';
import { jsx } from 'react/jsx-runtime';

function asyncComponent({
  loader,
  Placeholder,
  chunkName
}) {
  var _a;
  let Component$1 = null;
  return _a = class extends Component {
    /**
     * Static so that you can call load against an uninstantiated version of
     * this component. This should only be called one time outside of the
     * normal render path.
     */
    static load() {
      return loader().then((ResolvedComponent) => {
        Component$1 = ResolvedComponent.default || ResolvedComponent;
      });
    }
    static getChunkName() {
      return chunkName;
    }
    static getInitialProps(ctx) {
      if (Component$1 !== null) {
        return Component$1.getInitialProps ? Component$1.getInitialProps(ctx) : Promise.resolve(null);
      }
    }
    state = {
      Component: Component$1
    };
    componentDidMount() {
      _a.load().then(this.updateState);
    }
    updateState = /* @__PURE__ */ __name(() => {
      if (this.state.Component !== Component$1) {
        this.setState({
          Component: Component$1
        });
      }
    }, "updateState");
    render() {
      const { Component: ComponentFromState } = this.state;
      if (ComponentFromState) {
        return /* @__PURE__ */ jsx(ComponentFromState, { ...this.props });
      }
      if (Placeholder) {
        return /* @__PURE__ */ jsx(Placeholder, { ...this.props });
      }
      return null;
    }
  }, __name(_a, "AsyncRouteComponent"), _a;
}
__name(asyncComponent, "asyncComponent");

export { asyncComponent };
//# sourceMappingURL=asyncComponent.mjs.map
//# sourceMappingURL=asyncComponent.mjs.map